import { computed, shallowRef } from 'vue';
const dialogs = shallowRef<HTMLDialogElement[]>([]);
export function registerDialog(dialog: HTMLDialogElement): void {
  dialogs.value = [...dialogs.value.filter((item) => item !== dialog), dialog];
}
export function unregisterDialog(dialog: HTMLDialogElement): void {
  dialogs.value = dialogs.value.filter((item) => item !== dialog);
}
export function useActiveDialog() {
  return computed(() => dialogs.value.filter((dialog) => dialog.isConnected && dialog.open).at(-1));
}
